/**
 * ==========================================================
 * NA DEPOIMENTOS
 * Premium Carousel v3 (Optimized)
 * ----------------------------------------------------------
 * ✓ Scroll nativo
 * ✓ Paginação otimizada
 * ✓ Resize otimizado
 * ✓ requestAnimationFrame único
 * ✓ Menos reflows
 * ✓ Menos querySelector
 * ==========================================================
 */

document.addEventListener("DOMContentLoaded", () => {

  const section = document.querySelector(".na-depoimentos");
  if (!section) return;

  const viewport = section.querySelector(".na-depoimentos__viewport");
  const track = section.querySelector(".na-depoimentos__track");
  const cards = [...track.querySelectorAll(".na-depoimentos__card")];

  if (!cards.length) return;

  const prev = section.querySelector(".na-depoimentos__arrow--prev");
  const next = section.querySelector(".na-depoimentos__arrow--next");
  const pagination = section.querySelector(".na-depoimentos__pagination");

  /* ==========================================================
      MEDIDAS
  ========================================================== */

  const perView = () => {
    if (window.innerWidth <= 768) return 1;
    if (window.innerWidth <= 1024) return 3;
    return 4;
  };

  let step = 0;
  let dots = [];

  function updateMeasurements() {
    const gap = parseFloat(getComputedStyle(track).gap) || 0;
    step = cards[0].offsetWidth + gap;
  }

  function maxScroll() {
    return viewport.scrollWidth - viewport.clientWidth;
  }

  /* ==========================================================
      PAGINAÇÃO
  ========================================================== */

  function buildDots() {

    pagination.innerHTML = "";
    dots = [];

    const total = Math.ceil(cards.length / perView());

    for (let i = 0; i < total; i++) {

      const dot = document.createElement("button");
      dot.className = "na-depoimentos__dot";

      dot.addEventListener("click", () => {

        viewport.scrollTo({
          left: i * step * perView(),
          behavior: "smooth"
        });

      });

      pagination.appendChild(dot);
      dots.push(dot);

    }

  }

  /* ==========================================================
      UPDATE
  ========================================================== */

  function update() {

    const scroll = viewport.scrollLeft;

    prev?.classList.toggle("hidden", scroll <= 10);
    next?.classList.toggle("hidden", scroll >= maxScroll() - 10);

    const page = Math.round(scroll / (step * perView()));

    dots.forEach((dot, i) => {
      dot.classList.toggle("active", i === page);
    });

  }

  /* ==========================================================
      SETAS
  ========================================================== */

  prev?.addEventListener("click", () => {

    viewport.scrollBy({
      left: -step,
      behavior: "smooth"
    });

  });

  next?.addEventListener("click", () => {

    viewport.scrollBy({
      left: step,
      behavior: "smooth"
    });

  });

  /* ==========================================================
      SCROLL
  ========================================================== */

  let ticking = false;

  viewport.addEventListener("scroll", () => {

    if (ticking) return;

    ticking = true;

    requestAnimationFrame(() => {

      update();
      ticking = false;

    });

  }, { passive: true });

  /* ==========================================================
      RESIZE
  ========================================================== */

  let resizeTimeout;

  window.addEventListener("resize", () => {

    clearTimeout(resizeTimeout);

    resizeTimeout = setTimeout(() => {

      updateMeasurements();
      buildDots();
      update();

    }, 150);

  }, { passive: true });

  /* ==========================================================
      INIT
  ========================================================== */

  updateMeasurements();

  viewport.scrollLeft = 0;

  buildDots();

  update();

});